import React from 'react'

import localwindow from 'browser-lib/window'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import qs from 'querystring'

import api from 'common/api'

import OAuthButton from '.'
import './GoogleOAuthButton.scss'
import googleLogin from './btn-google-signin-dark-normal-web.png'

const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth'

class GoogleOAuthButton extends React.Component {
  signIn() {
    api.get('/api/oauth2/state?source=GoogleOAuth').then((result) => {
      const params = qs.stringify({
        access_type: 'offline',
        response_type: 'code',
        client_id: localwindow.GOOGLE_CLIENT_ID,
        state: result.State,
        redirect_uri: `https://${localwindow.location.host}/oauth/google/result`,
        scope: 'https://www.googleapis.com/auth/calendar',
        prompt: 'consent select_account',
      })
      this.props.onOAuthStart()
      localwindow.open(`${GOOGLE_AUTH_URL}?${params}`, 'Login', 'width=400,height=500')
    })
  }
  render() {
    return (
      <div className="google-oauth-button-comp">
        <OAuthButton
          onSignIn={() => this.signIn()}
          isReady={true}
          hasBorder={true}
        >
          <img
            src={googleLogin}
            alt="Sign in with Google"
          />
        </OAuthButton>
      </div>
    )
  }
}

GoogleOAuthButton.defaultProp = {
  onOAuthStart: noop,
}

GoogleOAuthButton.propTypes = {
  onOAuthStart: PropTypes.func,
}

export default GoogleOAuthButton
